import { motion } from "framer-motion";
import { SpecimenLabel } from "../SpecimenLabel";

export const FrameVelocity = () => {
  return (
    <section className="py-32 px-4 sm:px-6 lg:px-8 bg-muted/20 relative overflow-hidden">
      <div className="max-w-5xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="mb-8"
        >
          <SpecimenLabel text="VELOCITY" />
        </motion.div>

        {/* Large 60 display */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative inline-block"
        >
          <span className="font-editorial text-[12rem] md:text-[16rem] lg:text-[20rem] text-foreground leading-none">
            60
          </span>
          
          {/* Circular thread line */}
          <motion.svg
            className="absolute inset-0 w-full h-full"
            viewBox="0 0 100 100"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
          >
            <motion.circle
              cx="50"
              cy="50"
              r="45"
              fill="none"
              stroke="hsl(var(--brand-600) / 0.3)"
              strokeWidth="0.5"
              initial={{ pathLength: 0 }}
              whileInView={{ pathLength: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4, duration: 1.5, ease: "easeOut" }}
            />
          </motion.svg>
        </motion.div>

        {/* Specimen labels around */}
        <div className="flex flex-wrap justify-center gap-8 md:gap-16 mt-8">
          {[
            { label: "SECONDS", value: "to generate" },
            { label: "FORMATS", value: "at once" },
            { label: "REVISIONS", value: "included" }
          ].map((item, i) => (
            <motion.div
              key={item.label}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.5 + i * 0.1 }}
              className="text-center"
            >
              <p className="text-muted-foreground text-sm">{item.value}</p>
              <SpecimenLabel text={item.label} />
            </motion.div>
          ))}
        </div>

        {/* Copy */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6 }}
          className="mt-16 space-y-2"
        >
          <p className="text-xl md:text-2xl text-muted-foreground">
            Not minutes. Not AI-assisted.
          </p>
          <p className="font-editorial text-2xl md:text-3xl text-foreground">
            60 seconds. Start to publish.
          </p>
        </motion.div>
      </div>
    </section>
  );
};
